module.exports = __webpack_public_path__ + "static/media/stakeholders.b5ee5988.png";